const subscriptions = Symbol();

export function UnsubscribeOnDestroy(): any {
  return function(targetClass: any, key: string): any {
    if (!targetClass[subscriptions]) {
      targetClass[subscriptions] = [];
      const originalNgOnDestroy = targetClass.ngOnDestroy;
      targetClass.ngOnDestroy = function() {
        targetClass[subscriptions].forEach((subscription: string) => {
          this[subscription]?.unsubscribe?.();
        });
        originalNgOnDestroy?.apply(this);
      }
    }
    targetClass[subscriptions].push(key);
  }
}
